import { useEffect, useState } from "react"

export default function CheckLinkDomain(url) {
  const [linkUrl, setLinkUrl] = useState(null)

  useEffect(() => {
    var link = document.createElement("a")
    link.href = url
    if (!!link) {
      setLinkUrl(link.href.includes(window.location.origin))
    }
  }, [])
  return linkUrl
}
